export default "assets/images/icons/facebook-d319109b.svg";